import React from "react";
import { type FilterValues } from "components/filters/FilterContext";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import SubLabel from "components/Atoms/Sublabel";
import { mapAddressFilterToInstruction, mapKeywordFilterToInstruction, mapResponseToAddressFilter, mapResponseToKeywordFilter } from "components/filters/mappingUtils";
import SelectableList from "components/ListTemplate/SelectableList";
import AddressFilter from "components/filters/Filters/AddressFilter";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";

interface Props {
  onCompanySelected: (company: server.dto.CompanySmall) => void
  initialInstruction?: Partial<server.dto.PaginatedCompanyInstruction>
}

const SelectCompanyFromList = (props: Props) => {
  return <div className="flex grow1" style={{ minHeight: 0 }}>
    <SelectableList
      onSelect={props.onCompanySelected}
      perPage={20}
      defaultFilter={props.initialInstruction}
      initialInstruction={{
        page: 1,
        perPage: 20,
        ...props.initialInstruction
      }}
      excludeKeys={props.initialInstruction?.excludeKeys}
      excludeKeysName=""
      getId={item => item.companyId}
      fetchFunction={window.CoreApi.Company.Paginated}
      mapFilterValuesToInstruction={(values: FilterValues, page: number, perPage: number) => ({
        keyword: mapKeywordFilterToInstruction(values.keyword),
        address: mapAddressFilterToInstruction(values.address),
        excludeKeys: props.initialInstruction?.excludeKeys,
        page,
        perPage,
      })}
      mapResponseToFilterValues={(response: server.dto.ListCompanyFilters) => ({
        keyword: mapResponseToKeywordFilter(response.keyword),
        address: mapResponseToAddressFilter(response.address)
      })}
      filters={<>
        <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        <AddressFilter />
      </>}
      layout={{
        type: "card",
        sections: {
          renderTitle: () => null,
          hideTitle: () => true,
          renderFooter: () => null,
          hideFooter: () => true,
          renderBody: (item: server.dto.CompanySmall) =>
            <div className="flex gap">
              <div className="grow1">
                <div>{item.name}</div>
                <SubLabel>{item.cityCountry}</SubLabel>
              </div>
              {!item.isValidated && (
                <div>
                  <PhosphorWarning iconSize="large" />
                </div>)}
            </div>
        }
      }}
    />
  </div>
};

export default SelectCompanyFromList;
